export default "__VITE_ASSET__BE5IG0ir__"